import { Card, Section, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import atsCompanies from 'modules/ats/store/collections/atsCompanies'

export const ReferralsSettings = () => {
  const atsCompany = atsCompanies.current
  const hasReferralsEnabled = !!atsCompany?.attributes.referrals_enabled

  const { performAction: changeReferralsSettings } = useAsyncAction(async () => {
    await atsCompany?.update({ referrals_enabled: !hasReferralsEnabled })
    location.reload()
  })

  if (!atsCompany) {
    return null
  }

  return (
    <Section.TwoThirds
      illustration="diamond"
      title={i18n.t('app_store_v2.apps.ats.settings.open_positions_page.title')}
      description={i18n.t('app_store_v2.apps.ats.settings.open_positions_page.description')}
      link={{
        label: i18n.t('common.learn_more'),
        href: i18n.t('app_store_v2.apps.ats.settings.open_positions_page.help_center_url'),
      }}
    >
      <Card>
        <Card.Title
          size="small"
          action={
            <TogglerCheckbox value={hasReferralsEnabled} onChange={changeReferralsSettings} />
          }
        >
          {i18n.t('app_store_v2.apps.ats.settings.open_positions_page.toggle.title')}
        </Card.Title>
        <Card.Description>
          {i18n.t('app_store_v2.apps.ats.settings.open_positions_page.toggle.description')}
        </Card.Description>
      </Card>
    </Section.TwoThirds>
  )
}
